import * as Yup from "yup";

// Regular expression for validating an email address
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Regular expression for validating a password with specific criteria
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d#@$!%*?&]{8,}$/;

// Regular expression for validating an Indian phone number format
export const phoneRegex = /^[1-9]\d{9}$/;

// Regular expression for validating a name containing alphabetical characters, whitespace, and hyphens
export const nameRegex = /^[a-zA-Z\s-]+$/;

// Regular expression for validating a clinic name containing alphanumeric characters and space
export const clinicRegex = /^[a-zA-Z0-9 ]*$/;

// Regular expression for validating a number, including integers and floats
export const numberRegex = /^\d*\.?\d+$/;

export const validateEmail = (email) => emailRegex.test(email);
export const validatePassword = (password) => passwordRegex.test(password);
export const validatePhoneNumber = (phoneNumber) =>
  phoneRegex.test(phoneNumber);
export const validateName = (name) => nameRegex.test(name.trim());
export const validateClinic = (name) => clinicRegex.test(name.trim());
export const validateNumber = (number) =>
  numberRegex.test(number) && parseFloat(number) > 0;

//************** Yup ********************/

export const createValidationRule = (type, options = {}) => {
  const validationRules = {
    string: (message) =>
      Yup.string()
        .matches(/^[A-Za-z\s]+$/, message || "Must contain only letters")
        .required("This field is required"),
    number: (message) =>
      Yup.number()
        .positive("Value must be positive")
        .integer("Value must be an integer")
        .test("isNumber", "Number is only allowed", (value) => !isNaN(value))
        .required("This field is required"),
    phone: (message) =>
      Yup.string()
        .matches(
          /^[1-9]\d{9}$/,
          message || "Please enter a valid 10-digit phone number"
        )
        .required("Phone number is required"),
    email: (message) =>
      Yup.string().email("Invalid email address").required("Email is required"),
    password: (message) =>
      Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          message ||
            "Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Password is required"),
    confirmPassword: (message) =>
      Yup.string()
        .oneOf([Yup.ref("password"), null], message || "Passwords must match")
        .required("Confirm password is required"),
  };

  return validationRules[type](options.message);
};
